"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDummyShiftMiddlewareProps = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const ac_1 = require("@app/ac");
const shift_dummy_warnings_and_data_1 = __importDefault(require("@app/request/shift-dummy-warnings-and-data"));
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const shift_context_1 = require("../../shift-context");
const useDummyShiftMiddlewareProps = ({ control, getValues, initialData, trigger, initialLoad, variant, setErrors, }) => {
    const workspaceId = (0, useWorkspace_1.useWorkspace)()?.id;
    const [dummyShift, setDummyShift] = react_1.default.useState();
    const positions = (0, store_1.useRootSelector)((state) => state.positions);
    const { isValid } = (0, react_hook_form_1.useFormState)({ control });
    const values = (0, react_hook_form_1.useWatch)({ control });
    const dispatch = (0, store_1.useRootDispatch)();
    const loadDummyShift = async (shiftForm) => {
        const shiftData = { ...shiftForm };
        const isValid = await trigger();
        if (!isValid)
            return;
        if (!(0, shift_context_1.formHasPosition)(shiftData))
            // it can occur that shiftData position is removed
            return;
        // use random position, just to make dummy shift calculations work
        if (variant === 'transferSlave') {
            if (positions?.length && positions[0]?.id) {
                shiftData.position = positions[0].id;
            }
            else {
                return;
            }
        }
        const duration = (0, moment_1.default)(shiftData.period.end)
            .startOf('minute')
            .diff((0, moment_1.default)(shiftData.period.start).startOf('minute'), 'minutes');
        if (duration <= 0)
            return;
        await dispatch((0, ac_1.isLoading)(shift_context_1.LOADING_DUMMY_SHIFT_ACTION, false));
        const shiftId = initialData?.type === 'cycle' ? undefined : initialData?.shiftId;
        const { localityId, ...rest } = shiftData;
        const res = await (0, shift_dummy_warnings_and_data_1.default)({
            workspaceId,
            data: { ...rest, locality: localityId },
            id: shiftId,
        }, setErrors).catch(async () => {
            await dispatch((0, ac_1.isLoading)(shift_context_1.LOADING_DUMMY_SHIFT_ACTION, true));
            return undefined;
        });
        if ((0, util_1.isDefined)(res)) {
            setDummyShift(res);
            await dispatch((0, ac_1.isLoading)(shift_context_1.LOADING_DUMMY_SHIFT_ACTION, true));
            return res;
        }
        await dispatch((0, ac_1.isLoading)(shift_context_1.LOADING_DUMMY_SHIFT_ACTION, true));
    };
    react_1.default.useEffect(() => {
        if (initialLoad)
            return;
        void loadDummyShift(getValues());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialLoad, values, getValues, JSON.stringify(getValues()), isValid, variant]);
    return {
        dummyShift,
        loadDummyShift,
    };
};
exports.useDummyShiftMiddlewareProps = useDummyShiftMiddlewareProps;
